<script lang="ts" setup>
import type { EditorialModalVideo } from '@integration-layer/ampliance/schemas/editorial-modal-video-schema.localized'

const props = defineProps<{
  deliveryId: string
  locale: string
  vse?: string
  content?: EditorialModalVideo
}>()

const data = await useComponentResponse<EditorialModalVideo>(props)

// @ts-ignore - Ignoring since modalContent doesn't contain media in zod generated type
const media = data.value?.modalContent?.media
</script>

<template>
  <OrganismsModal :id="deliveryId" dark-background>
    <template #body>
      <UIMedia v-if="media" class="mx-auto max-h-screen" :media="media" />
    </template>
  </OrganismsModal>
</template>
